import { axios } from "@sdk/axios";
import { PaginatedResults } from "@sdk/utils/paginated-results";
import { AxiosResponse } from "axios";
import { iDynamicForm } from "./dangerous-deletion-model";

export class DangerousDeletionServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {}

  dangerousDeletion = {
    deleteOrganization: async (confirmation: string) => {
      const results: AxiosResponse<PaginatedResults<iDynamicForm>> =
        await axios.post(
          this.config.basePath + `/dangerous-deletion/delete-organization`,
          { confirmation },
          {
            headers: {
              Authorization: this.config.token,
            },
          }
        );
      return results.data;
    },
    resetOrganization: async (confirmation: string) => {
      const results: AxiosResponse<PaginatedResults<iDynamicForm>> =
        await axios.post(
          this.config.basePath + `/dangerous-deletion/reset-organization`,
          { confirmation },
          {
            headers: {
              Authorization: this.config.token,
            },
          }
        );
      return results.data;
    },
  };
}
